import { StreamingVideoUrl, VideoInfoProcess } from '../../../../../../../../../@types/types'
import React from 'react'
import styles from './VideoThumbnail.module.css'

export type VideoThumbnailProps = {
  ariaLabel: string | undefined
  videoInfoSourceTeaserUrl: false | string | undefined
  videoSourceWhenUploading: VideoInfoProcess | undefined
  videoInfoSourceUrls: StreamingVideoUrl[]
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  ariaLabel,
  videoInfoSourceTeaserUrl,
  videoSourceWhenUploading,
  videoInfoSourceUrls,
}) => {
  return (
    <video
      data-testid='video-thumbnail'
      aria-label={ariaLabel}
      className={`block absolute border-radius-rounded ${styles.videoThumbnail}`}
      poster={videoInfoSourceTeaserUrl ? videoInfoSourceTeaserUrl : videoSourceWhenUploading?.videoInfo?.teaserUrl}
    >
      {videoInfoSourceUrls.map((src) => (
        <source key={src.url} src={src.url} />
      ))}
      Your browser does not support the video tag.
    </video>
  )
}

export default VideoThumbnail
